export enum ClaimHeaderMaxLengths {
  CustomerReferenceNumber = 20,
  ReassignReasonNumber = 100,
}
